module.exports = __webpack_public_path__ + "img/pablo_micas.a7bb37b9.png";